import type { Bordereau, Exercice } from '@mairistem/comptabilite';
import type TreeviewActionResult from '../../interfaces/pieces/TreeviewActionResult';
import type { BaseLiquidationOptions } from '../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import { BordereauWithState } from '../../interfaces/pieces/TreeRow';

class BaseLiquidationAction<T, U> {
  label: string;

  type: U;

  isSuperUser: boolean = false;

  isActionPrincipale: boolean = false;

  /**
   * Prédicat optionnel pour contrôler l’affichage de l’action dans l’UI.
   * S’il est absent, l’action est affichée.
   */
  isShown: (bordereau: BordereauWithState, data?: T) => boolean = () => true;

  constructor(options : BaseLiquidationOptions = null) {
    this.isSuperUser = options?.isSuperUser;
    this.isActionPrincipale = options?.isActionPrincipale;
  }

  execute: (data: T, exercice: Exercice, bordereau: Bordereau | BordereauWithState) => TreeviewActionResult<T> | TreeviewActionResult<T>[];

  executeAction?: (
    data: T,
    exercice: Exercice
  ) => TreeviewActionResult<T> | TreeviewActionResult<T>[];
}

export default BaseLiquidationAction;
